import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

/**
 * En QR-kode tegnet som SVG, så den er skarp både på skærm og på papir.
 *
 * Bruges to steder: mærkatet på en enhed (DeviceLabel) og hemmeligheden til
 * authenticator-appen, når to-faktor sættes op (beslutning 035).
 */
export function QrCode({
  value,
  size = 128,
  errorCorrectionLevel = 'M'
}: {
  value: string
  size?: number
  /** "M" tåler ca. 15 % skade - nok til et mærkat der bliver snavset i et teknikrum. */
  errorCorrectionLevel?: 'L' | 'M' | 'Q' | 'H'
}) {
  const [svg, setSvg] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    void QRCode.toString(value, { type: 'svg', errorCorrectionLevel, margin: 1, width: size }).then((result) => {
      if (!cancelled) setSvg(result)
    })

    return () => {
      cancelled = true
    }
  }, [value, size, errorCorrectionLevel])

  if (!svg) {
    // Samme plads som den færdige kode, så siden ikke hopper når den er tegnet.
    return <div style={{ width: size, height: size, background: '#F1F5F9' }} />
  }

  return <div style={{ width: size, height: size }} dangerouslySetInnerHTML={{ __html: svg }} />
}
